module.exports = __webpack_public_path__ + "static/media/promo-overlay-registry.01945d9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/registry/promo-overlay-registry.png
// module id = 1727
// module chunks = 53